import templateUrl from 'emun.customer/customer-vendors-purchased.htm'
import controller from 'emun.customer/customer-vendors-purchased.controller'

export default {
    bindings: {
        customer: '<',
        repGroup: '@',
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};